import { useRef, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";

export const UploadZone = ({ onFileSelected, isLoading }) => {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFile = (file) => {
    if (!file) return;
    onFileSelected(file);
  };

  return (
    <div
      data-testid="invoice-upload-zone"
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        handleFile(e.dataTransfer.files?.[0]);
      }}
      onClick={() => !isLoading && inputRef.current?.click()}
      className={`bg-white border-2 border-dashed rounded-[10px] p-16 flex flex-col items-center justify-center text-center cursor-pointer transition-colors duration-200 ${
        dragOver ? "border-[#0E6E52] bg-[#E4F1EB]" : "border-[#DCE3DF]"
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
        className="hidden"
        data-testid="invoice-file-input"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      {isLoading ? (
        <>
          <Loader2 className="w-10 h-10 text-[#0E6E52] animate-spin mb-4" />
          <p className="text-base font-medium text-[#141E1A]" data-testid="extraction-loading-message">
            Gemini is reading your invoice…
          </p>
          <p className="text-sm text-[#5A6B63] mt-1">Extracting fields, this takes a few seconds.</p>
        </>
      ) : (
        <>
          <UploadCloud className="w-10 h-10 text-[#0E6E52] mb-4" />
          <p className="text-base font-medium text-[#141E1A]">Drop an invoice here, or click to browse</p>
          <p className="text-sm text-[#5A6B63] mt-1">PDF, PNG or JPG · GST tax invoice</p>
        </>
      )}
    </div>
  );
};
